/* Menu hover */

$('.custom-nav').children('li').each(function() {
  
  $(this).find('a').hover(function() {
    var current = $(this).attr('id');
    $(this).addClass('active');
    $(this).parent().siblings().find('a').removeClass('active');
    
  	$('.custom-nav').find('section.'+current).addClass('shown');
    $('.custom-nav').find('section.'+current).siblings().removeClass('shown');
  });
});

$('.custom-arrow').click(function() {
  $(this).toggleClass('active');
  $(this).parent().parent().find('ul.mobile-nav__sublist').toggle();
});

$('.faq-container').each(function() {
  $(this).find('.faq-item').click(function() {
    $(this).toggleClass('active');
  });
});